// @ts-nocheck
import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { SafeDictionary } from "@insite/client-framework/Common/Types";
import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import { PageLinkModel } from "@insite/client-framework/Services/ContentService";
import { getDataView, getDataViewKey } from "@insite/client-framework/Store/Data/DataState";
import { loadPagesForParent } from "@insite/client-framework/Store/Data/Pages/PagesActionCreators";
import { getCurrentPage, getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getPageLinkByNodeId, getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import PageProps from "@insite/client-framework/Types/PageProps";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import LocalizedDateTime from "@insite/content-library/Components/LocalizedDateTime";
import Button from "@insite/mobius/Button";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import LoadingOverlay, { LoadingOverlayProps } from "@insite/mobius/LoadingOverlay";
import Pagination, { PaginationPresentationProps } from "@insite/mobius/Pagination";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import convertToNumberIfString from "@insite/mobius/utilities/convertToNumberIfString";
import getColor from "@insite/mobius/utilities/getColor";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";

import GridContainer, { GridContainerProps } from "@store/MobiusOverrides/GridContainer/GridContainer";
import GridItem, { GridItemProps, GridWidths } from "@store/MobiusOverrides/GridItem/GridItem";
import Img from "@store/MobiusOverrides/Img/Img";
import constants from "@store/constants";
import loadResults from "@store/Framework/Store/Store/Pages/BlogList/Handlers/LoadResults";
import stripHtml from "@toolkit/Framework/Common/Utilities/stripHtml";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { spacingStyles } from "@toolkit/Themes/common/mixins";
import parse from "html-react-parser";
import sortBy from "lodash/sortBy";
import truncate from "lodash/truncate";
import * as React from "react";
import { FC } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const enum fields {
    defaultPageSize = "defaultPageSize",
    itemsPerRow = "itemsPerRow",
    defaultCardImage = "defaultCardImage",
    noSearchResultsMessage = "noSearchResultsMessage",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.defaultPageSize]: number;
        [fields.itemsPerRow]: number;
        [fields.defaultCardImage]: string;
        [fields.noSearchResultsMessage]: string;
    };
    isSearchPage: boolean;
}

const mapStateToProps = (state: Toolkit.Store.ApplicationState, ownProps: OwnProps) => {
    const location = getLocation(state);
    const parsedQueryString = parseQueryString<{ page?: string; pageSize?: string; query?: string }>(location.search);
    const searchId = `blog-${getDataViewKey({ query: parsedQueryString.query })}`;
    const currentPage = getCurrentPage(state);
    const isSearchPage = currentPage.type === constants.pageType.blogList;
    const parameterId = isSearchPage ? searchId : currentPage.nodeId;
    const pagesDataView = getDataView(state.data.pages, {
        parentNodeId: parameterId,
    });
    const pages = {
        ...pagesDataView,
        value: pagesDataView.value?.filter(x => x.type === constants.pageType.blogPost),
    };
    let links: SafeDictionary<PageLinkModel> = {};
    if (pages.value) {
        links = pages.value.reduce(
            (links, page) => ({ ...links, [page.nodeId]: getPageLinkByNodeId(state, page.nodeId) }),
            {},
        );
    }
    return {
        parentNodeId: getCurrentPage(state).nodeId,
        pages,
        isSearchPage,
        links,
        location,
        parameter: {
            page: parsedQueryString.page ? convertToNumberIfString(parsedQueryString.page) : undefined,
            pageSize: parsedQueryString.pageSize ? convertToNumberIfString(parsedQueryString.pageSize) : undefined,
            id: parameterId,
            query: parsedQueryString.query,
        },
    };
};

const mapDispatchToProps = {
    loadPagesForParent,
    loadResults,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & HasHistory;

export interface BlogListViewStyles {
    loadingOverlay?: LoadingOverlayProps;
    listContainer?: GridContainerProps;
    blogListWrapper?: InjectableCss;
    searchResultsListTitle?: TypographyProps;
    blogHeaderPagesText?: InjectableCss;
    blogItem?: GridItemProps;
    blogItemWrapper?: InjectableCss;
    postImageWrapper?: InjectableCss;
    postImage?: InjectableCss;
    titleText?: TypographyProps;
    dateAndAuthorWrapper?: InjectableCss;
    authorImageWrapper?: InjectableCss;
    authorImage?: InjectableCss;
    postImagePlaceholder?: InjectableCss;
    authorTextWrapper?: InjectableCss;
    authorText?: TypographyProps;
    publishDateText?: TypographyProps;
    textWrapper?: InjectableCss;
    summaryWrapper?: InjectableCss;
    readMoreLink?: LinkPresentationProps;
    paginationWrapper?: InjectableCss;
    pagination?: PaginationPresentationProps;
    noResultsTextWrapper?: InjectableCss;
}

const commonPostImageStyles = `position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    `;

export const blogListViewStyles: BlogListViewStyles = {
    listContainer: {
        gap: 20,
    },
    searchResultsListTitle: {
        variant: "h1",
        color: "primary",
    },
    blogHeaderPagesText: {
        css: css`
            ${spacingStyles()}
            text-align: right;
        `,
    },
    blogItemWrapper: {
        css: css`
            flex-direction: column;
            height: 100%;
            width: 100%;
            max-width: 100%;
            padding: 0;
            border: 1px solid ${getColor("common.border")};
        `,
    },
    postImageWrapper: {
        css: css`
            position: relative;
            padding-top: ${(630 / 1200) * 100}%;
        `,
    },
    postImage: {
        css: css`
            ${commonPostImageStyles}
            object-fit: cover;
        `,
    },
    postImagePlaceholder: {
        css: css`
            ${commonPostImageStyles}
            background: linear-gradient(210deg, ${getColor("common.accent")}, ${getColor("common.borderDark")});
        `,
    },
    titleText: {
        variant: "h5",
        as: "h3",
    },
    dateAndAuthorWrapper: {
        css: css`
            display: flex;
            padding: ${pxToRem(8, 15)};
            width: 100%;
            background-color: ${getColor("common.accent")};
        `,
    },
    authorImageWrapper: {
        css: css`
            margin-right: ${pxToRem(15)};
        `,
    },
    authorImage: {
        css: css`
            max-width: ${pxToRem(50)};
            max-height: ${pxToRem(50)};
            width: auto;
            height: auto;
            align-items: center;
        `,
    },
    authorTextWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            justify-content: center;
        `,
    },
    authorText: {
        css: css`
            font-size: ${x => x.theme.design.typography.size.small};
            margin-right: ${pxToRem(15)};
        `,
    },
    publishDateText: {
        css: css`
            font-style: italic;
            font-size: ${x => x.theme.design.typography.size.smaller};
        `,
    },
    textWrapper: {
        css: css`
            padding: ${pxToRem(15)};
        `,
    },
    summaryWrapper: {
        css: css`
            ${spacingStyles()}
            font-size: ${x => x.theme.design.typography.size.small};
        `,
    },
    readMoreLink: {
        typographyProps: {
            css: css`
                text-align: right;
                font-size: ${x => x.theme.design.typography.size.small};
            `,
        },
    },
    paginationWrapper: {
        css: css`
            display: flex;
            justify-content: center;
            margin-top: ${pxToRem(30)};
            width: 100%;
        `,
    },
    pagination: {
        cssOverrides: {
            pagination: css`
                padding-top: ${pxToRem(15)};
            `,
        },
    },
    noResultsTextWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            gap: ${pxToRem(15)};
        `,
    },
};

const styles = blogListViewStyles;

const BlogListView: FC<Props> = ({
    links,
    pages,
    fields,
    isSearchPage,
    location,
    parameter,
    history,
    loadResults,
    loadPagesForParent,
}) => {
    const { defaultPageSize, itemsPerRow, defaultCardImage, noSearchResultsMessage } = fields;

    if (!pages.value && !pages.isLoading) {
        if (isSearchPage) {
            loadResults({
                id: parameter.id,
                query: parameter.query,
                page: parameter.page,
                pageSize: parameter.pageSize,
            });
        } else {
            loadPagesForParent({
                page: parameter.page,
                pageSize: parameter.pageSize,
                parentNodeId: parameter.id,
            });
        }
    }

    const changePage = (newPageIndex: number) => {
        updateQueryString(newPageIndex, parameter.pageSize);
    };

    const changeResultsPerPage = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const newPageSize = parseInt(event.currentTarget.value, 10);
        updateQueryString(1, newPageSize);
    };

    const updateQueryString = (page: number, pageSize?: number) => {
        let newLocation = `${location.pathname}?${
            isSearchPage && parameter.query ? `query=${parameter.query}&` : ""
        }page=${page}`;
        if (pageSize) {
            newLocation += `&pageSize=${pageSize}`;
        }
        history.push(newLocation);
    };

    const totalItems = pages.value?.length || 0;
    const page = parameter.page ?? 1;
    const pageSize = parameter.pageSize ?? defaultPageSize;
    const totalPages = Math.ceil(totalItems / pageSize);

    const sortedAndPagedPages = sortBy(pages.value, o => o.fields["publishDate"])
        .reverse()
        .slice((page - 1) * pageSize, page * pageSize);

    return (
        <StyledWrapper {...styles.blogListWrapper}>
            {isSearchPage && (
                <Typography {...styles.searchResultsListTitle}>
                    {parameter.query
                        ? `${translate("Search Results for")} "${parameter.query}"`
                        : translate("Search Results")}
                </Typography>
            )}
            <LoadingOverlay loading={!pages.value || pages.isLoading} {...styles.loadingOverlay}>
                {totalItems > 0 && !pages.isLoading ? (
                    sortedAndPagedPages.length ? (
                        <>
                            {totalItems > pageSize && (
                                <StyledWrapper {...styles.blogHeaderPagesText}>
                                    <Typography>
                                        {translate("Page {0} of {1}")
                                            .replace("{0}", page.toString())
                                            .replace("{1}", totalPages.toString())}{" "}
                                        &mdash; {translate("Total of {0} posts").replace("{0}", totalItems.toString())}
                                    </Typography>
                                </StyledWrapper>
                            )}
                            <GridContainer {...styles.listContainer}>
                                {sortedAndPagedPages.map((page: PageProps) => (
                                    <GridItem
                                        width={[12, 6, itemsPerRow, itemsPerRow, itemsPerRow] as GridWidths[]}
                                        key={page.id}
                                    >
                                        <StyledWrapper {...styles.blogItemWrapper}>
                                            <StyledWrapper {...styles.postImageWrapper}>
                                                <Link href={links[page.nodeId]?.url}>
                                                    {page.fields["openGraphImage"] ? (
                                                        <Img
                                                            src={page.fields["openGraphImage"]}
                                                            {...styles.postImage}
                                                        />
                                                    ) : defaultCardImage ? (
                                                        <Img src={defaultCardImage} {...styles.postImage} />
                                                    ) : (
                                                        <StyledWrapper {...styles.postImagePlaceholder}></StyledWrapper>
                                                    )}
                                                </Link>
                                            </StyledWrapper>
                                            <StyledWrapper {...styles.dateAndAuthorWrapper}>
                                                {page.fields["authorImage"] && (
                                                    <StyledWrapper {...styles.authorImageWrapper}>
                                                        <Img src={page.fields["authorImage"]} {...styles.authorImage} />
                                                    </StyledWrapper>
                                                )}
                                                <StyledWrapper {...styles.authorTextWrapper}>
                                                    {page.fields["authorName"] && (
                                                        <Typography {...styles.authorText}>
                                                            {page.fields["authorName"]}
                                                        </Typography>
                                                    )}
                                                    {page.fields["publishDate"] && (
                                                        <Typography {...styles.publishDateText}>
                                                            <LocalizedDateTime
                                                                dateTime={new Date(page.fields["publishDate"])}
                                                                options={{
                                                                    year: "numeric",
                                                                    month: "long",
                                                                    day: "numeric",
                                                                }}
                                                            />
                                                        </Typography>
                                                    )}
                                                </StyledWrapper>
                                            </StyledWrapper>
                                            <StyledWrapper {...styles.textWrapper}>
                                                <Typography variant="h2" {...styles.titleText}>
                                                    <Link href={links[page.nodeId]?.url}>{page.fields["title"]}</Link>
                                                </Typography>
                                                {(page.fields["blogShortDestriction"] || page.fields["blogIntro"]) && (
                                                    <StyledWrapper {...styles.summaryWrapper}>
                                                        {parse(
                                                            stripHtml(page.fields["blogShortDestriction"] || "") ||
                                                                truncate(stripHtml(page.fields["blogIntro"] || ""), {
                                                                    length: 240,
                                                                }),
                                                            parserOptions,
                                                        )}
                                                    </StyledWrapper>
                                                )}
                                                <Link href={links[page.nodeId]?.url} {...styles.readMoreLink}>
                                                    {translate("Read More")}
                                                </Link>
                                            </StyledWrapper>
                                        </StyledWrapper>
                                    </GridItem>
                                ))}
                            </GridContainer>
                            {totalItems > pageSize && (
                                <StyledWrapper {...styles.paginationWrapper}>
                                    <Pagination
                                        resultsCount={totalItems}
                                        currentPage={page}
                                        resultsPerPage={pageSize}
                                        resultsPerPageOptions={[pageSize, pageSize * 2, pageSize * 3, pageSize * 4]}
                                        onChangePage={changePage}
                                        onChangeResultsPerPage={changeResultsPerPage}
                                        pageSizeCookie="BlogList-PageSize"
                                        {...styles.pagination}
                                    />
                                </StyledWrapper>
                            )}
                        </>
                    ) : null
                ) : null}
                {totalItems === 0 && !pages.isLoading ? (
                    <StyledWrapper {...styles.noResultsTextWrapper}>
                        <Typography>
                            {translate('No results for "{0}".').replace(
                                "{0}",
                                parameter.query || translate("this search query"),
                            )}
                        </Typography>
                        {noSearchResultsMessage && (
                            <Typography>{parse(noSearchResultsMessage, parserOptions)}</Typography>
                        )}
                    </StyledWrapper>
                ) : null}
            </LoadingOverlay>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: withHistory(connect(mapStateToProps, mapDispatchToProps)(BlogListView)),
    definition: {
        group: constants.widgetGroup.blogList,
        allowedContexts: [constants.pageType.blogHome, constants.pageType.blogList] as any,
        fieldDefinitions: [
            {
                name: fields.defaultPageSize,
                editorTemplate: "IntegerField",
                defaultValue: 5,
                fieldType: "General",
                min: 1,
                max: 20,
                sortOrder: 101,
            },
            {
                name: fields.itemsPerRow,
                editorTemplate: "DropDownField",
                defaultValue: 4,
                fieldType: "General",
                options: [
                    {
                        displayName: "2",
                        value: 6,
                    },
                    {
                        displayName: "3",
                        value: 4,
                    },
                    {
                        displayName: "4",
                        value: 3,
                    },
                ],
                sortOrder: 102,
            },
            {
                name: "defaultCardImage",
                defaultValue: "",
                editorTemplate: "ImagePickerField",
                tooltip: "Suggested size: 1200x630, like OpenGraph Image",
                fieldType: "General",
                sortOrder: 103,
            },
            {
                name: "noSearchResultsMessage",
                editorTemplate: "RichTextField",
                tooltip:
                    "When used in context of a Search Results page, this text will be shown when no results are found.",
                fieldType: "Translatable",
                defaultValue: "Make a new search or go back to the Blog home page.",
                sortOrder: 104,
            },
        ],
    },
};

export default widgetModule;
